// extracted by mini-css-extract-plugin
export default {"navbarMenu":"sidebar_navbarMenu__qxyJ4","containerfluid":"sidebar_containerfluid__myGlw"};